import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
import {
  AnalysisParamValue,
  SerializedSideEffects,
} from "pages/gdt/store/SideEffects";

export const workflowTableRowExecute = djangoClientQueryFactory(
  { method: "post", path: "/library/workflow_table_row/bulk_execute/" },
  {
    formatInput: (
      rows: {
        id: string;
        param_values: {
          column: string;
          value: AnalysisParamValue;
        }[];
        side_effects: SerializedSideEffects;
      }[],
    ) => {
      return {
        body: rows,
      };
    },

    handleResponse: (res) => {
      const created = res.data;

      assert(
        created !== undefined,
        "Expected data to be defined when creating rows",
      );
      return created;
    },
  },
);
